import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { USER } from '../users'

export const collection = 'comments'

export const schema = new schemas.Entity(collection, {
  user: USER.schema,
})

type FetchPropsType = {
  caseId: string
  id: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ caseId, id }: FetchPropsType) =>
    callApi(`${apiBase}/cases/${caseId}/events/${id}`, schema)

type CreatePropsType = {
  caseId: string
  parentId?: string
}

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { caseId, parentId, ...body }: CreatePropsType) => {
    let url = `${apiBase}/cases/${caseId}/events`

    if (parentId) {
      url = `${url}/${parentId}`
    }

    return callApi(url, schema, {
      method: 'POST',
      body: {
        caseId,
        parentId,
        ...body,
      },
    })
  }
